import React, { PropTypes } from 'react';
import { get, isNil, union } from 'lodash';
import shortid from 'shortid';
import cx from 'classnames';

function AddButtonGroupItem(props) {

  const clientId = shortid.generate();

  const handleAdd = (event) => {
    if (props.onAdd && get(event, 'target.value')) {
      props.onAdd(event, clientId, get(event, 'target.value'));
    }
  };

  const handleEnter = (event) => {
    if (event.key === 'Enter') {
      handleAdd(event);
    }
  };

  return (
    <li
      className='button-group-item add'
      data-id='ADD'>
      {
      <input className='adding-button-group-item'
        key={clientId}
        placeholder={'ADD'}
        type='text'
        name='newItem'
        defaultValue={''}
        maxLength='48'
        onBlur={handleAdd}
        onKeyUp={handleEnter}
      />
      }
    </li>
  );
}

AddButtonGroupItem.propTypes = {
  onAdd : PropTypes.func
};

function ButtonGroupItem(props) {
  const {
    value,
    name,
    selected,
    onToggle
  } = props;

  const handleToggle = (event) => {
    if (onToggle) {
      onToggle(event, value, !selected);
    }
  };

  return (
    <li
      onClick={handleToggle}
      className={cx('button-group-item noTextSelect', {active: selected})}
    >
    {
      name
    }
    </li>
  );
}

ButtonGroupItem.propTypes = {
  value   : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name    : PropTypes.string,
  selected: PropTypes.bool,
  onToggle: PropTypes.func
};

export default function ButtonGroup(props) {

  const {
    value,
    items,
    allowAdd = true,
    onToggle,
    onAdd
  } = props;

  const menuItems = union(value, items)
    .reduce((acc, curr) => {
      if(!acc.find(i => i.value === curr.value)) {
        acc.push(curr);
      }
      return acc;
    }, [])
  ;

  const handleToggle = (event, val, selected) => {
    if (onToggle) {
      onToggle(event, val, selected);
    }
  };

  const handleAdd = (event, val, name) => {
    if (onAdd) {
      return onAdd({ value: val, name});
    }
  };

  return (
    <div className='button-group-container-wrapper'>
      <ul className='button-group-container'>
      {
        menuItems.map((item) => {
          return (
            <ButtonGroupItem
              value={item.value}
              name={item.name}
              selected={!!value.find(val => val.value === item.value)}
              onToggle={handleToggle}
            />
          );
        })
      }
      {
        allowAdd &&
        <AddButtonGroupItem onAdd={handleAdd}/>
      }
      </ul>
    </div>
  );
}

ButtonGroup.propTypes = {
  value   : PropTypes.array,
  items   : PropTypes.array,
  showNone: PropTypes.bool,
  allowAdd: PropTypes.bool,
  onToggle: PropTypes.func,
  onAdd   : PropTypes.func
};



// WEBPACK FOOTER //
// ./shared/common/components/ButtonGroup.js